import React, { Suspense, useEffect, useRef } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { ClientReducerState } from 'client/reducers';

type Props = ConnectedProps<typeof connector> & {
	html: string;
	onChange: (editorState: any) => void;
	onComplete: () => void;
	editableRef: React.RefObject<HTMLDivElement>;
};

const RichEditor = React.lazy(() => import('client/components/common/RichEditor'));

const ContentEditable = ({ html, onChange, onComplete, editableRef, selection }: Props) => {
	const id = editableRef.current?.id ?? '';
	const isSelected = useRef(selection[id] !== undefined);

	useEffect(
		function completeOnSelectionChange() {
			if (isSelected.current && !selection[id]) {
				onComplete();
			}

			isSelected.current = selection[id] !== undefined;
		},
		[onComplete, selection, id]
	);

	return (
		// eslint-disable-next-line react/no-danger
		<Suspense fallback={<div dangerouslySetInnerHTML={{ __html: html }} />}>
			<RichEditor html={html} onChange={onChange} />
		</Suspense>
	);
};

const connector = connect(({ editor }: ClientReducerState) => ({ selection: editor.selection.clicked }));

export default connector(ContentEditable);
